var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wl-tree-menu"},_vm._l((_vm.commentList),function(item,index){return _c('ul',{key:index,staticClass:"wl-tree-item wl-tree-root"},[_c('tree-item',{ref:"tree",refInFor:true,attrs:{"data":item,"index":index,"onAdd":_vm.onAdd}})],1)}),0)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }